import React from "react"
import { ERRORS } from "./constants"
import styles from "./Dropdown.module.css"
import Label from "./Label"
import RequiredNotice from "./RequiredNotice"

const Dropdown = (props) => {
  const { id, label, onChange, value, defaultValue, required, footerText, options, error, className, testId } = props

  if (options.length === 0) {
    return null
  }
  return (
    <div className={`${styles.container} ${className}`} data-testid="dropdown-component">
      <Label id={id} required={required} hasError={Boolean(error)}>
        {label}
      </Label>
      <select
        id={id}
        data-testid={testId || "select"}
        aria-label={label}
        value={value || defaultValue}
        className={`${styles.select} ${error ? styles.error : ""}`}
        onChange={(e) => onChange(e.target.value)}
      >
        {options.map((option) => (
          <option data-testid="dropdown-option" key={option.value} value={option.value} disabled={option.disabled}>
            {option.label}
          </option>
        ))}
      </select>
      <RequiredNotice required={required} hasError={error === ERRORS.required} />
      {footerText && (
        <span className={styles.footerText} data-testid="footer-text">
          {footerText}
        </span>
      )}
    </div>
  )
}

Dropdown.defaultProps = {
  value: "",
  error: "",
  onChange: () => {},
  options: [],
  className: "",
}

export default Dropdown
